import type { MotionNodeAnimationOptions } from "motion/react";
import type { ReactNode, Ref } from "react";

import { Stage } from "./stage";

type ToggleStageProps<T> = {
  status: boolean;
  fallback?: ReactNode;
  children: ReactNode | ((data: NonNullable<T>) => ReactNode);
  className?: string;
  options?: MotionNodeAnimationOptions;
  data?: T;
  ref?: Ref<HTMLDivElement>;
};

export function ToggleStage<T>({
  status,
  fallback,
  children,
  className,
  options,
  data,
  ref,
}: ToggleStageProps<T>) {
  return (
    <Stage>
      <Stage.Scene status={!status} className={className}>
        {fallback}
      </Stage.Scene>
      {typeof children === "function" ? (
        <Stage.Scene
          data={status ? data : null}
          className={className}
          options={options}
          ref={ref}
        >
          {children}
        </Stage.Scene>
      ) : (
        <Stage.Scene default className={className} options={options} ref={ref}>
          {children}
        </Stage.Scene>
      )}
    </Stage>
  );
}

export type { ToggleStageProps };
